// Sonidos cortos de feedback para respuestas correctas/incorrectas.
// Se generan en el momento con la Web Audio API (dos tonos osciladores) en
// vez de depender de archivos .mp3/.wav -- asi no se necesita subir nada a
// Storage ni cargar un archivo adicional por cada ejercicio.
let ctxCompartido = null

function obtenerContexto() {
  if (typeof window === 'undefined') return null
  const AudioContextClase = window.AudioContext || window.webkitAudioContext
  if (!AudioContextClase) return null
  if (!ctxCompartido) ctxCompartido = new AudioContextClase()
  // Los navegadores suspenden el AudioContext hasta que hay una interaccion
  // del usuario; como estos sonidos siempre se disparan despues de un clic
  // (responder, comprobar, etc.), aqui solo lo reanudamos por si quedo en
  // "suspended" de una pantalla anterior.
  if (ctxCompartido.state === 'suspended') ctxCompartido.resume().catch(() => {})
  return ctxCompartido
}

function tono(ctx, frecuencia, inicioSeg, duracionSeg, volumen) {
  const osc = ctx.createOscillator()
  const gain = ctx.createGain()
  osc.type = 'sine'
  osc.frequency.value = frecuencia
  const t0 = ctx.currentTime + inicioSeg
  gain.gain.setValueAtTime(0, t0)
  gain.gain.linearRampToValueAtTime(volumen, t0 + 0.015)
  gain.gain.exponentialRampToValueAtTime(0.0001, t0 + duracionSeg)
  osc.connect(gain)
  gain.connect(ctx.destination)
  osc.start(t0)
  osc.stop(t0 + duracionSeg + 0.02)
}

// Dos notas cortas ascendentes (como un "ding!" alegre) -> respuesta correcta
export function sonidoCorrecto() {
  const ctx = obtenerContexto()
  if (!ctx) return
  try {
    tono(ctx, 740, 0, 0.11, 0.16)
    tono(ctx, 988, 0.09, 0.18, 0.18)
  } catch { /* si el navegador bloquea audio, simplemente no sonamos */ }
}

// Un solo tono grave y corto -> respuesta incorrecta (informativo, no agresivo)
export function sonidoIncorrecto() {
  const ctx = obtenerContexto()
  if (!ctx) return
  try {
    tono(ctx, 220, 0, 0.2, 0.13)
  } catch { /* idem */ }
}
